import { connect } from 'react-redux'

import { setOpenModalPreviewLogo } from 'reduxpath/ducks/Service/List'

import ModalPreviewLogo from './units'

const mapStateToProps = state => ({
  isOpenModalPreviewLogo: state.ServiceList.isOpenModalPreviewLogo,
  imageLogo: state.ServiceList.inputDataService.logo,
})

const mapDispatchToProps = dispatch => ({
  setOpenModalPreviewLogo(data) {
    return () => {
      dispatch(setOpenModalPreviewLogo(data))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalPreviewLogo)
